var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-goods-page',{attrs:{"initial-shop-type":1,"embedded":true,"title":"抖店商品 - 我的商品"}})
}
var staticRenderFns = []

export { render, staticRenderFns }